import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';

import {
  LEAVE_GROUP_ORDER_MODAL,
  EMPTY_CART_CONFIRMATION_MODAL
} from 'constants/cart';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { getOwnCartDrawerState } from 'styles/helpers/getSecondaryButtonState';
import { useDisableCartButtonsForGroupOrderGuest } from 'bento-ordering/group_ordering/hooks/index';

const LeaveGroupOrderSpacer = styled('div')`
  padding: 0.5rem;
`;

const GroupOrderGuestCartCTAs = ({ toggleIsOpen }) => {
  /**
   * render "Leave Group Order" if group order and:
   *   - current diner is guest
   *   - group order cart is not closed
   *   - group order guest is not done ordering
   */
  const disableCartButtonsForGroupOrderGuest = useDisableCartButtonsForGroupOrderGuest();

  return (
    <Box marginTop={2} marginBottom={2}>
      <SecondaryCta
        handleClick={() => toggleIsOpen(EMPTY_CART_CONFIRMATION_MODAL)}
        label="Empty Cart"
        dataTestId="cart-empty-button"
        ownState={getOwnCartDrawerState()}
        disabled={disableCartButtonsForGroupOrderGuest}
      />
      {!disableCartButtonsForGroupOrderGuest && (
        <>
          <LeaveGroupOrderSpacer />
          <SecondaryCta
            handleClick={() => toggleIsOpen(LEAVE_GROUP_ORDER_MODAL)}
            label="Leave Group Order"
            dataTestId="leave-group-order-button"
            ownState={getOwnCartDrawerState()}
          />
        </>
      )}
    </Box>
  );
};

GroupOrderGuestCartCTAs.propTypes = {
  toggleIsOpen: PropTypes.func.isRequired
};

export default GroupOrderGuestCartCTAs;
